<template>
  <div>
    <h1 class="flex mb-8 font-bold text-3xl">
      <icon name="questionnaires" class="w-6 mr-3 fill-gray-700" /> Atalhos
    </h1>

    <div class="mb-6 flex justify-between items-center">
      <text-input class="w-full max-w-md mr-4" placeholder="Buscar..." />

      <inertia-link class="btn-indigo" :href="route('shortcuts.create')">
        <span>Criar</span>

        <span class="hidden md:inline">Atalho</span>
      </inertia-link>
    </div>

    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold flex items-center">
          <th class="px-6 pt-6 pb-4 label">Nome</th>
          <th class="px-6 pt-6 pb-4 url">Url</th>
          <th class="px-6 pt-6 pb-4 icon">Ícone</th>
        </tr>
        <tr
          v-for="(shortcut, index) in shortcuts"
          :key="index"
          v-if="shortcuts.length > 0"
          class="flex items-center"
        >
          <td class="border-t px-6 py-4 label">
            <button
              class="hover:underline mr-2 my-auto"
              type="button "
              @click="destroyShortcut(shortcut.id)"
            >
              <icon name="trash" class="flex-shrink-0 w-4 h-4 fill-red-600" />
            </button>

            <span @click="edit(shortcut.id)">
              {{ shortcut.label }}
            </span>
          </td>
          <td class="border-t px-6 py-4 url" @click="edit(shortcut.id)">
            {{ shortcut.url }}
          </td>
          <td class="border-t px-6 py-4 icon" @click="edit(shortcut.id)">
            {{ shortcut.icon }}
          </td>
        </tr>

        <tr v-else>
          <td class="border-t px-6 py-4" colspan="4">Nenhum registro</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'

import TextInput from '../../Shared/TextInput'

export default {
  metaInfo: { title: 'Questionários' },
  components: {
    Icon,
    TextInput,
  },
  layout: Layout,
  props: {
    shortcuts: Array,
  },
  data() {
    return {}
  },
  methods: {
    destroyShortcut(id) {
      console.log(id)
      this.$inertia.delete(this.route('shortcuts.destroy', id))
    },

    edit(id) {
      this.$inertia.get(this.route('shortcuts.edit', id))
    },
  },
  mounted() {
    console.log(this.shortcuts)
  },
}
</script>

<style>
.mr-21 {
  margin-right: 5.5rem;
}

.label {
  min-width: 250px;
}

.url,
.icon {
  min-width: 150px;
}
</style>
